<template>
  <div :class="['card--owner-connect', { 'is-shortlist': isShortlist }]" v-if="listing">
    <div class="unavailable--overlay" v-if="listing.status === 'NOT_ACTIVE'">
      <div class="overlay--content">
        <v-icon class="close-icon" color="#8b0000" size="64">mdi-close-circle</v-icon>
        <p class="overlay--text">Listing ini sudah tidak tersedia atas<br />permintaan owner</p>
      </div>
    </div>
    <div class="d-flex align-items-start">
      <div class="label--container">
        <div class="label" v-if="listing.property_type">{{ listing.property_type }}</div>
        <div class="label label--type" v-if="listing.listing_type">
          {{ listing.listing_type === 'R' ? $t('general.rent') : $t('general.sell') }}
        </div>
        <div class="specs--info mr-1" v-if="listing.bedroom">
          <v-icon small>mdi-bed</v-icon>
          <span>{{ listing.bedroom }}</span>
        </div>
        <div class="specs--info mr-1" v-if="listing.bathroom">
          <v-icon small>mdi-shower-head</v-icon>
          <span>{{ listing.bathroom }}</span>
        </div>
      </div>
      <div class="d-flex ml-auto align-items-center">
        <div class="remove--button" v-show="isShortlist">
          <button class="btn btn-remove" type="button" @click="removeFromShortlist">
            <v-icon>mdi-delete-outline</v-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="land--info mb-3" v-if="listing.land_size || listing.building_size">
      <div class="info--item" v-if="listing.land_size">
        <span class="info--label">LT:</span>
        <span class="info--value">{{ listing.land_size }} m<sup>2</sup></span>
      </div>
      <div class="info--item" v-if="listing.building_size">
        <span class="info--label">LB:</span>
        <span class="info--value">{{ listing.building_size || 12 }} m<sup>2</sup></span>
      </div>
    </div>

    <div class="description--box mb-2" v-if="listing.description">
      <p class="mb-0">
        {{ listing.description }}
      </p>
    </div>

    <div class="location mb-2" v-if="listing.area || listing.city">
      <v-icon small>mdi-map-marker</v-icon>
      <div v-clampy="2">
        <span>{{ listing.area }}</span>
        <span v-if="listing.area && listing.city">, </span>
        <span>{{ listing.city }}</span>
      </div>
    </div>

    <div class="no--item d-flex align-items-center" v-if="listing.inquiry_number">
      <span class="no--label">No.</span>
      <span class="no--value me-1">{{ listing.inquiry_number }}</span>
      <v-icon small class="cursor-pointer" @click="copyInquiryNumber" title="Copy No">
        mdi-content-copy
      </v-icon>
      <v-snackbar v-model="showSnackbarNumber" timeout="2000" color="#8b0000" rounded top>
        Nomor berhasil disalin!
      </v-snackbar>
    </div>

    <div class="price--section mb-2">
      <div class="price--label">{{ $t('general.price') }}</div>
      <div class="price--value">{{ $n(listing.price, 'currency', 'id-ID') }}</div>
    </div>

    <div class="commission--section" v-if="hasCommission">
      <span>Komisi</span>
      <strong>{{ formattedCommission }}</strong>
    </div>
    <div class="commission--disclaimer" v-if="listing.commission_disclaimer">
      {{ listing.commission_disclaimer }}
    </div>

    <div class="action--button">
      <button class="btn btn--contact w-100" type="button" @click="addToShortlist">
        <div :class="['contact--content', { covered: !isShortlist }]">
          <v-icon class="phone-icon">mdi-whatsapp</v-icon>
          <span>{{ isShortlist ? listing.requester_name : '08XX - XXXX - XXX' }}</span> -
          <span>{{ isShortlist ? listing.phone_number : '08XX - XXXX - XXX' }}</span>
          <v-snackbar v-model="showSnackbar" timeout="2000"> Kontak berhasil disalin! </v-snackbar>
        </div>
        <div class="button--cover" v-show="!isShortlist">{{ $t('ownerConnect.clickToSee') }}</div>
      </button>
    </div>
  </div>
</template>

<script>
import HelperMixin from '@/mixins/helpers';
import { mapState } from 'vuex';

export default {
  mixins: [HelperMixin],
  props: {
    listing: {
      default: null,
      require: true,
    },
    isShortlist: {
      default: false,
      require: true,
    },
  },
  data: () => ({
    debounceCompare: null,
    copyPhoneNumberSucceededPhoneNumber: null,
    showSnackbar: false,
    copiedPhoneNumber: null,
    showSnackbarNumber: false,
  }),
  computed: {
    ...mapState({
      shortlists: (state) => state.searchListing.shortlists,
      isLoggedIn: (state) => state.global.loggedIn,
      user: (state) => state.global.user,
    }),
    loading: {
      get() {
        return this.$store.state.searchListing.isLoading;
      },
      set(value) {
        this.$store.commit('searchListing/SET_IS_LOADING', value);
      },
    },
    commissionValue() {
      if (!this.listing) return null;
      return this.listing.commission;
    },
    hasCommission() {
      return (
        this.commissionValue !== null &&
        this.commissionValue !== undefined &&
        this.commissionValue !== ''
      );
    },
    formattedCommission() {
      if (!this.hasCommission) return '-';
      const commission = Number(this.commissionValue);
      if (Number.isNaN(commission)) return '-';
      return `${
        Number.isInteger(commission) ? commission : commission.toFixed(2).replace(/\.?0+$/, '')
      }%`;
    },
  },
  methods: {
    addToShortlist() {
      if (!this.isShortlist) {
        this.toggleShortlist('ADD');
      } else {
        const phone = this.listing.phone_number;
        if (!phone) return;

        // navigator.clipboard.writeText(phone);
        // this.handleCopyPhoneNumberStatus(phone);

        const formattedPhone = phone.replace(/\D/g, '');
        const whatsappNumber = formattedPhone.startsWith('62')
          ? formattedPhone
          : '62' + formattedPhone.replace(/^0+/, '');

        const ownerName = this.listing.requester_name || 'Bapak/Ibu';
        const agentName = this.user && this.user.name ? this.user.name : 'Agen BeliRumah';
        const inquiryNumber = this.listing.inquiry_number || '-';
        const text = `Halo ${ownerName}, perkenalkan saya ${agentName}, agen terdaftar dari BeliRumah.co. Saya mendapatkan kontak Bapak/Ibu melalui fitur Owner Connect BeliRumah.co dan ingin membantu Anda untuk menjual properti yang Anda miliki dengan nomor ID Inquiry ${inquiryNumber}.`;
        const waUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
        window.open(waUrl, '_blank');
      }
    },
    removeFromShortlist() {
      if (this.isShortlist) {
        this.toggleShortlist('REMOVE');
      }
    },
    async handleCopyPhoneNumberStatus(phoneNumber) {
      this.copiedPhoneNumber = phoneNumber;
      this.showSnackbar = true; // ✅ munculkan snackbar
      setTimeout(() => {
        this.showSnackbar = false; // ✅ otomatis hilang setelah 2 detik
      }, 2000);
    },
    async copyInquiryNumber() {
      try {
        const number = this.listing?.inquiry_number || '12';
        await navigator.clipboard.writeText(number);
        this.showSnackbarNumber = true;
      } catch (error) {
        console.error('Gagal menyalin nomor:', error);
      }
    },
    async toggleShortlist(type) {
      try {
        this.loading = true;
        if (type === 'REMOVE') {
          await this.$store.dispatch(
            'ownerConnect/toggleOwnerConnectInquiry',
            this.listing.owner_connect_inquiry_id,
          );
        } else {
          await this.$store.dispatch('ownerConnect/toggleOwnerConnectInquiry', this.listing.id);
        }
        if (type === 'ADD') {
          const result = await this.$swal({
            type: 'success',
            title: this.$t('general.success'),
            text: this.$t('ownerConnect.saveToShortlistSuccess'),
            showCancelButton: true,
            confirmButtonText: 'Ke Favorit Saya',
            cancelButtonText: 'Tutup',
            reverseButtons: true,
          });

          if (result.value) {
            await this.$router.push({ name: 'shortlist' });
          }
        } else if (type === 'REMOVE') {
          await this.$swal(
            this.$t('general.success'),
            this.$t('ownerConnect.removeShortlistSuccess'),
            'success',
          );
          this.$emit('refresh');
        }
      } finally {
        this.loading = false;
      }
    },
  },
  filters: {
    lowerCase(e) {
      return e.toLowerCase();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';
.card--owner-connect {
  background: #ffffff;
  border: 1px solid #e7dada;
  border-radius: 16px;
  padding: 18px 18px 16px;
  height: 100%;
  box-shadow: 0 12px 28px rgba(35, 35, 35, 0.07);
  position: relative;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 34px rgba(35, 35, 35, 0.1);
  }

  .label--container {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    align-items: center;
    padding-right: 46px;

    .label {
      background: #8b0000;
      color: #ffffff;
      padding: 5px 10px;
      border-radius: 8px;
      font-size: 12px;
      font-family: Poppins-Bold, sans-serif;
      white-space: nowrap;
      height: 26px;
      display: flex;
      align-items: center;

      &.label--type {
        background-color: #6fcf2f;
        color: $color-white;
      }
    }
  }

  .specs--info {
    display: flex;
    align-items: center;
    gap: 4px;
    background: #f5f5f5;
    padding: 4px 10px;
    border: 1px solid #eeeeee;
    border-radius: 8px;
    height: 26px;

    .v-icon {
      font-size: 18px;
      color: #666;
    }

    span {
      font-size: 12px;
      font-weight: 500;
      color: #333;
    }
  }

  .remove--button {
    position: absolute;
    top: 16px;
    right: 16px;

    .btn-remove {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      min-width: 38px;
      height: 38px;
      padding: 0;
      border: 1px solid #f0d6d6;
      border-radius: 10px;
      background: #fffdfd;
      color: $color-beliruma-1;
      box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
      z-index: 10;

      .v-icon {
        margin: 0;
        color: $color-beliruma-1;
        font-size: 21px;
      }

      &:hover {
        background: #fff6f6;
      }
    }
  }

  .land--info {
    display: flex;
    gap: 6px;
    .info--item {
      display: flex;
      align-items: center;
      gap: 4px;
      background: rgb(213, 92, 6);
      padding: 4px 12px;
      border-radius: 8px;

      .info--label {
        font-size: 12px;
        font-weight: 800;
        color: whitesmoke;
      }

      .info--value {
        font-size: 12px;
        font-weight: 900;
        color: whitesmoke;
      }
    }
  }
  .no--item {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 10px;

    .no--label {
      font-size: 13px;
      color: #666;
    }

    .no--value {
      font-size: 13px;
      font-weight: 900;
      color: #666;
    }
  }

  .description--box {
    background: #f7f7f7;
    padding: 12px;
    border-radius: 10px;

    p {
      font-size: 13px;
      color: #333;
      line-height: 1.5;
    }
  }

  .location {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 14px;
    color: #666;

    .v-icon {
      font-size: 16px;
      color: #666;
      margin-top: 2px;
    }

    div {
      flex: 1;
      line-height: 1.4;
    }
  }

  .price--section {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .price--label {
      font-size: 13px;
      color: #666;
      font-weight: 500;
    }

    .price--value {
      font-size: 17px;
      font-weight: 700;
      color: #000;
    }
  }

  .commission--section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px dashed #d5121b;
    border-radius: 9px;
    padding: 13px 18px;
    margin: 0 0 8px;
    font-size: 13px;

    span {
      color: #696969;
    }

    strong {
      color: $color-text-black;
    }

    @media #{$phones} {
      padding: 12px 16px;
      font-size: 13px;
    }
  }

  .commission--disclaimer {
    color: #8a8a8a;
    font-family: Poppins;
    font-size: 11px;
    line-height: 1.5;
    margin-bottom: 28px;
  }

  .action--button {
    .btn--contact {
      background: #28a745;
      border: none;
      color: #ffffff;
      padding: 10px 12px;
      border-radius: 999px;
      font-weight: 600;
      font-size: 13px;
      position: relative;
      overflow: hidden;
      transition: background 0.3s;

      &:hover {
        background: #0c531c;
      }

      .contact--content {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        min-width: 0;
        white-space: normal;
      }

      .covered {
        gap: 8px;
        span {
          font-size: 14px;
        }
      }

      .button--cover {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #28a745;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 600;
      }
    }
  }
}

// Utility classes
.d-flex {
  display: flex;
}

.align-items-start {
  align-items: flex-start;
}

.align-items-center {
  align-items: center;
}

.ml-auto {
  margin-left: auto;
}

.w-100 {
  width: 100%;
}

.phone-icon {
  color: white;
}
.listing--unavailable {
  position: relative;
  pointer-events: none;
  opacity: 0.6;
}

.unavailable--overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  .overlay--content {
    text-align: center;
    padding: 20px;

    .close-icon {
      margin-bottom: 16px;
      animation: pulse 2s infinite;
    }

    .overlay--text {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      line-height: 1.6;
      margin: 0;
    }
  }
}

// Animasi pulse untuk icon X
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}
</style>
